import React, { Component } from 'react';
import config from "./../config.json";
import authFetch from "../authFetch";
import DepartmanCard from '../components/departmanCard';
import ToastCard from '../components/toast';
import RightMenu from '../components/rightMenu'


class DepartmanSayfa extends Component {
  state = {
    departmanlar: [],
    showDetail: false,
    departmanDetail: {},
    response: {},
    showToast: false,
    datetime: Date.now(),
  }

  headers = {
    Authorization : 'Bearer ' +  (localStorage.getItem('user')  == null ? '' : JSON.parse(localStorage.getItem('user'))["token"]),
    'Content-Type': 'application/json',
  }

  componentDidMount() {
    this.setValues();
    document.title = "Altınkaynak Personel Sistemi - Departmanlar"
  }

  componentWillUnmount() {
  }

  async setValues() {
    var departmanlar = [];
    await authFetch(config.apiEndpoint + 'departments', {method: 'GET', headers:this.headers}).then(function(response) {
      return response.json();
    })
    .then(function(jsonStr) {
      departmanlar = jsonStr;
    });

    this.setState({ departmanlar })

  }


  cleanupModalAfterClose = () => {
    const modalElement = document.getElementById('modalCenter');
    if (!modalElement) {
      return;
    }
    if (window.bootstrap && window.bootstrap.Modal) {
      const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    } else {
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.removeAttribute('aria-modal');
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      const modalBackdrops = document.getElementsByClassName('modal-backdrop');
      while (modalBackdrops.length > 0) {
        modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
      }
    }
  }

  handleOpenModal = (departmanDetail) => {
    this.setState({ showDetail: true, departmanDetail: departmanDetail });
  }

  handleCloseModal = (event) => {
    this.setState({ showDetail: false }, () => {
      this.cleanupModalAfterClose();
    });
  }

  handleAddDepartment = (event) => {
    this.setState({ showDetail: true, departmanDetail: {} });
  }

  handleSaveForm = async (event) => {
    event.preventDefault();

    const departmanDetailChanged = Object.assign({}, this.state.departmanDetail);

    departmanDetailChanged.Adi = event.target['Adi'].value;

    var mesaj = '';
    let response;
    let responseOk = false;
    if (departmanDetailChanged.DepartmanId == null) {
      response = await authFetch(config.apiEndpoint + 'departments/', {method: 'POST', body:JSON.stringify(departmanDetailChanged), headers:this.headers});
    }
    else {
      this.setState({ departmanDetail: departmanDetailChanged });
      response = await authFetch(config.apiEndpoint + 'departments/' + this.state.departmanDetail.DepartmanId, {method: 'PUT', body:JSON.stringify(departmanDetailChanged), headers:this.headers});
    }
    responseOk = response.ok;
    mesaj = await response.json();

    if (responseOk) {
      this.setState({ showDetail: false, response: mesaj, showToast: true, datetime: Date.now(), }, () => {
        this.cleanupModalAfterClose();
      });
    } else {
      this.setState({ response: mesaj, showToast: true, datetime: Date.now(), });
    }
    this.setValues();
  }

  handleDeleteDepartment = async (departmanDetail) => {
    var mesaj = '';
    await authFetch(config.apiEndpoint + 'departments/' + departmanDetail.DepartmanId, {method: 'DELETE', headers:this.headers}).then(function(response) {
      return response.json();
    })
    .then(function(jsonStr) {
      mesaj = jsonStr;
    });
    this.setState({ response: mesaj, showToast: true, datetime: Date.now(), });
    this.setValues();
  }

  render() {
    return <React.Fragment>
      <RightMenu />

      <ToastCard response={this.state.response} showToast={this.state.showToast} datetime={this.state.datetime} />
      <div className="modal fade" id="modalCenter" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            {this.state.showDetail ?
              <form id="formAuthenticationc" className="mb-3" onSubmit={this.handleSaveForm}>
                <div className="modal-header">
                  <h5 className="modal-title" id="modalCenterTitle">{this.state.departmanDetail['Adi']}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row g-2">
                    <div className="col mb-0 form-floating">
                      <input
                        type="text"
                        id="Adi"
                        name="Adi"
                        className="form-control"
                        placeholder="Adı"
                        key={this.state.departmanDetail['Adi']}
                        defaultValue={this.state.departmanDetail['Adi']}
                      />
                      <label htmlFor="Adi" className="form-label">Adı</label>
                    </div>

                  </div>

                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">Kaydet</button>
                </div>
              </form> : null}
          </div>
        </div>
      </div>

      <div className="content-wrapper">

        <div className="container-xxl flex-grow-1 container-p-y">
          <h4 className="fw-bold py-2 mb-1">Departmanlar
            <button type="button" className="btn btn-outline-primary thin ml20" data-bs-toggle="modal"
              data-bs-target="#modalCenter" onClick={this.handleAddDepartment}>
              <i className="tf-icons bx bx-building"></i>
              Departman Ekle
            </button>
          </h4>
          
          <div className="row row-cols-1 row-cols-md-3 g-4 mb-5">
            <table className="table">
              <thead>
                <tr>
                  <th>Adı</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {this.state.departmanlar.map(tag => <DepartmanCard key={tag['Adi']} parentCallback={this.handleOpenModal} parentDeleteCallback={this.handleDeleteDepartment} values={tag} />)}
              </tbody>
            </table>
          </div>

        </div>

        <footer className="content-footer footer bg-footer-theme">
          <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
            <div className="mb-2 mb-md-0">
              © Altınkaynak
            </div>
          </div>
        </footer>

        <div className="content-backdrop fade"></div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>

    </React.Fragment>;
  }
}

export default DepartmanSayfa;
